import { CompetitorPricingPage } from '../../components/comparisons/CompetitorPricingPage';
import { COMPETITOR_PRICING_MAX_AGE_DAYS, getCompetitorPricing } from '../../data/competitor-pricing';
import { warnStaleEntries } from '../../data/pseo/staleness';
import { isPublishable } from '../../data/pseo/types';

/**
 * Filestage Pricing (2026): thin page over the shared pricing template. Numbers come from `competitor-pricing.ts`.
 */
const entry = getCompetitorPricing('filestage');

const WHEN_COMPETITOR_IS_BETTER = [
    "You proof live websites or HTML. Filestage reviews them; Kreatli has no website proofing.",
    "You prefer one flat monthly price that covers 10 seats over per-seat billing.",
    "You want approve or request-changes decisions with due dates and reminders.",
    "Your designers work in Photoshop or InDesign and want an integration there. Kreatli has no editing or design-software plugins.",
];

export default function FilestagePricingPage() {
  return (
    <CompetitorPricingPage
      entry={entry}
      documentTitle="Filestage Pricing (2026): Plans, Seats & Real Cost"
      metaDescription="Filestage pricing explained: Free, Starter (€199) and Business (€329) flat plans with 10 seats, the free plan limits, and what 3 to 15 seats cost."
      h1="Filestage Pricing (2026)"
      heroText="Filestage’s flat-priced plans, what the 10 included seats mean for small and growing teams, and the limits on the free plan."
      publishDate="2026-10-22 00:00"
      readTimeMinutes="7"
      coverSrc="/images/comparisons/filestage-alternatives-2026-cover.jpg"
      coverAlt="Filestage pricing breakdown"
      summary="Filestage charges one flat monthly price in EUR, and every plan includes 10 seats. That suits teams close to 10 people; a team of 3 pays the same as a team of 10. Past 10 seats you buy packs of 5, which aren’t priced on the pricing page."
      whenCompetitorIsBetter={WHEN_COMPETITOR_IS_BETTER}
    />
  );
}

export function getStaticProps() {
  warnStaleEntries('competitor-pricing', [entry], COMPETITOR_PRICING_MAX_AGE_DAYS);
  if (!isPublishable(entry)) {
    return { notFound: true };
  }
  return { props: {} };
}
